import request from '@/common/utils/request';

export default {
  // 申请合作
  addCooperationIntention: data => request({
    url: '/web/data/addCooperationIntention',
    method: 'POST',
    data,
  }),
};
